"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _AppConstants = _interopRequireDefault(require("../../../../constants/AppConstants"));
var _ServiceRegistry = _interopRequireDefault(require("../../../../util/ServiceRegistry"));
var _Events = require("../../../../constants/Events");
var _AppUtil = require("../../../../util/AppUtil");
var _ComponentRegistry = _interopRequireDefault(require("../../../../util/ComponentRegistry"));
var _class, _class2, _descriptor;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/**
 * Container component for file info in integration header
 */
let HeaderFileInfoContainer = (0, _mobxReact.observer)(_class = (_class2 = class HeaderFileInfoContainer extends _react.Component {
  constructor(props) {
    super(props);
    _initializerDefineProperty(this, "showFileName", _descriptor, this);
    this._loggingService = _ServiceRegistry.default.getService("LoggingService");
  }
  componentDidMount() {
    _ServiceRegistry.default.getService("EventsService").registerEventListener(_Events.InternalEvents.FILE_NAME_TOAST_VISIBILITY, eventData => this.setShowFileName(!eventData));
  }
  setShowFileName(value) {
    this.showFileName = (0, _AppUtil.isMobileBrowser)() ? false : value;
  }
  get isFileNameVisible() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    const previewConfig = appStore.getActionConfig("preview");
    if (appStore.enableModernViewer && appStore.isSizedPreset) {
      return appStore.inFullScreen && !(0, _AppUtil.isMobileBrowser)();
    }
    return !previewConfig.showFileNameToast && (this.showFileName || appStore.hideFileNameToast);
  }
  render() {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (appStore.dropinName === "combinepdf" || appStore.dropinName === "signintegration" || appStore.dropinName === "managesignintegration" || appStore.hideHeaderFileInfo) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
    let status;
    let fileStatus;
    let enableSaveButton = false;
    let showSaveButton = false;
    this.fileMetadata = appStore.fileInfoList && appStore.fileInfoList.length > 0 ? appStore.fileInfoList[0].metaData : undefined;
    if (!this.fileMetadata) {
      return null;
    }
    const previewConfig = appStore.getActionConfig("preview");
    if (!appStore.configStore.isThumbnailView) {
      fileStatus = appStore.fileStatus;
      const isDirty = appStore.isDirty;
      const saveInProgress = fileStatus === _AppConstants.default.FILE_PROGRESS_STATUS.SAVING;
      const isEditAllowed = appStore.isInPreview && appStore.isEditAllowed && (previewConfig.showAnnotationTools || previewConfig.enableFormFilling);
      enableSaveButton = isDirty && !saveInProgress;
      showSaveButton = isEditAllowed;
      if (fileStatus === _AppConstants.default.FILE_PROGRESS_STATUS.SAVED || appStore.showLoader) {
        fileStatus = undefined;
      }
      if (enableSaveButton && showSaveButton) {
        fileStatus = _AppConstants.default.FILE_PROGRESS_STATUS.EDITED;
      }
    }
    if (previewConfig.showFileStatusInfo || previewConfig.showAnnotationTools || previewConfig.enableFormFilling) {
      if (appStore.hasReadOnlyFile) {
        status = "file.metadata.readonly";
      } else if (appStore.editAllowed === false) {
        status = "file.metadata.protected";
      }
    }
    if (appStore.configStore.getSaveCallbackConfig().showSaveButton === false) {
      showSaveButton = false;
      // As we are not showing Save button so check if we need to remove status as well
      if (appStore.configStore.getSaveCallbackConfig().showEditStatusInfo === false) {
        fileStatus = undefined;
      }
    }
    if (appStore.showViewMode) {
      fileStatus = undefined;
    }
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ComponentRegistry.default.getComponent("HeaderFileInfoView", {
      showFileName: this.isFileNameVisible,
      fileStatus,
      showSaveButton: showSaveButton && !appStore.enableModernViewer,
      disableSaveButton: !enableSaveButton,
      fileMetadata: this.fileMetadata,
      status
    }));
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "showFileName", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return !(0, _AppUtil.isMobileBrowser)();
  }
}), _applyDecoratedDescriptor(_class2.prototype, "setShowFileName", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "setShowFileName"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isFileNameVisible", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isFileNameVisible"), _class2.prototype)), _class2)) || _class;
var _default = exports.default = (0, _reactIntl.injectIntl)(HeaderFileInfoContainer);